import { render, staticRenderFns } from "./SpeechModal.vue?vue&type=template&id=6887a5c6&scoped=true&"
import script from "./SpeechModal.vue?vue&type=script&lang=js&"
export * from "./SpeechModal.vue?vue&type=script&lang=js&"
import style0 from "./SpeechModal.vue?vue&type=style&index=0&id=6887a5c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887a5c6",
  null
  
)

export default component.exports